import { render, staticRenderFns } from "./TheUserDropdown.vue?vue&type=template&id=a4c17d80&scoped=true&"
import script from "./TheUserDropdown.vue?vue&type=script&lang=js&"
export * from "./TheUserDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TheUserDropdown.vue?vue&type=style&index=0&id=a4c17d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c17d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu})
